var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isLink
    ? _c(
        "RouterLink",
        { staticClass: "text-label truncate", attrs: { to: _vm.routeParams } },
        [_vm._v(" " + _vm._s(_vm.content) + " ")]
      )
    : _c("span", { staticClass: "text-label truncate", class: _vm.classes }, [
        _vm._v(" " + _vm._s(_vm.content) + " "),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }